import React from "react";
import {Field, FieldArray, reduxForm} from "redux-form/immutable";
import TextInputField from "../../../components/forms/TextInputField";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import FormError from "../../../components/forms/FormError";
import TextAreaInputField from "../../../components/forms/TextAreaInputField";
import Checkbox from "../../../components/forms/Checkbox";
import styles from "./ConsignmentCommandForm.module.scss";


function ConsignmentCommandForm(props) {
  const {
    handleSubmit, submit, submitting, onCancel, errors,
    change,
    commandOptions,
    tracking_nr_options,
    locationsTips,
    withMessageField,
  } = props;

  function handleActionButton(command_id, submit) {
    change("commandName", command_id)
    setTimeout(submit, 0)
  }

  function handleLocationChange(value) {
    change("location", value)
  }
  
  return (
    <form className="ConsignmentCommandForm" onSubmit={handleSubmit}>
      <div className="fields">
        <FormFieldsTable>
          <FieldArray name="trackingNrs" props={{serverError: errors.trackingNrs}} component={(fieldProps) => renderTrackingNumbers(tracking_nr_options, fieldProps)} />
          {/* <FieldError error={errors.trackingNrsError} showClientError={true} clientError={true} /> */}
          <Field
            label="Location"
            name="location"
            component={TextInputField}
          />
          <LocationTips tips={locationsTips} onLocationChange={handleLocationChange} />
          {withMessageField && <Field
            label="Message"
            name="message"
            component={TextAreaInputField}
          />}
        </FormFieldsTable>
      </div>
      <FormError error={errors._error} />
      <div className="buttons" style={{flexWrap: "wrap"}}>
        {commandOptions.map((option) => 
          <ActionButton key={option.get("id")}
            label={submitting ? "Standby" : option.get("title")}
            style={{width: "inherit", flexGrow: 1}}
            primary={true} onClick={() => handleActionButton(option.get("id"), submit)}
            active={!submitting}
          />
        )}
        <ActionButton label="Cancel" primary={false} onClick={onCancel} active={!submitting} />
      </div>
    </form>
  )
}

function renderTrackingNumbers(tracking_nr_options, _fieldsProps) {
  return tracking_nr_options.map((option, index) =>
    <tr key={option.get("id")} className={styles.trackingNumbersField}>
      <td>
        <div>
          <Field
            label={option.get("title")}
            name={`trackingNrs[${index}]`}
            component={Checkbox}
            noMargin={true}
            table={true}
          />
        </div>
      </td>
    </tr>
  );
}

function LocationTips({tips, onLocationChange}) {
  return (
    <tr className={styles.locationTips}>
      <td>
        <ul className="TextInputField">
          {tips.map((tip) => (
            <li key={tip.get("id")}
              className="TextInput"  
              onClick={() => onLocationChange(tip.get("title"))}>
              {tip.get("title")}
            </li>
          ))}
        </ul>
      </td>
    </tr>
  )
}

const ReduxForm = reduxForm({
  form: "ConsignmentCommandForm",
  // Allow update of fields through changes to initialValues
  enableReinitialize: true,
  // Prevent such updates from impacting fiels that were edited by the user
  keepDirtyOnReinitialize: true,
})(ConsignmentCommandForm);

export default ReduxForm;